import { Component, EventEmitter, Input, Output } from '@angular/core';
import { nav_path } from '../../../app-routing.module';
import { Story } from '../../interfaces/story';
import { RoutingService } from '../../../core/services/routing.service';
import { RemoveStoryTitlePipe } from '../../pipes/remove-story-title.pipe';

@Component({
  selector: 'anon-story-header',
  templateUrl: './story-header.component.html',
  styleUrls: ['./story-header.component.scss']
})
export class StoryHeaderComponent {
  public readonly nav_path = nav_path;
  @Output() previewClicked = new EventEmitter<boolean>(false);
  @Input() story!: Story;

  constructor(
    public routing: RoutingService,
    public rst: RemoveStoryTitlePipe
  ) {}

  previewStory(isClicked: boolean) { this.previewClicked.emit(isClicked); }
}
